















import AbpBase from "../../../lib/abpbase";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import {
    SaveTabTitle
} from "../../../api/systemBasic";
import util from "../../../lib/util";

@Component({})
export default class extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Object, default: {} }) data: any;
  form: any = {
    Id:0,
    name:""
  };
  created() {
   
  }
  rules = {
  };
  cancel() {
    (this.$refs.form as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  async save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        let res = await SaveTabTitle(this.form);
        if (res.status == 1) {
          this.$emit("input", false);
          this.$emit("on-success");
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/tabMaintain/title.vue